import { API_LINKS } from "./api";

export const getDelegationAcceptStartUrl = (token: string) =>
  `${API_LINKS.baseUrl}/DelegationAccept/start?token=${encodeURIComponent(token)}`;
